"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.factorial = factorial;
function factorial(n, logger) {
    if (n < 0) {
        logger === null || logger === void 0 ? void 0 : logger.error('Factorial cannot be calculated on a negative number');
        return 1;
    }
    var result = 1;
    for (var i = 2; i <= n; i++) {
        result = result * i;
    }
    return result;
}
